import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  background-color: #fff;
  padding: 20px;
  font-size: 0.815rem;
  border: 1px solid #f2f2f2;
  border-top: none;

  &:first-child {
    border-top: 1px solid #f2f2f2;
  }

  @media screen and (min-width: 992px) {
    &:nth-of-type(-n + 3) {
      border-top: 1px solid #f2f2f2;
    }

    &:nth-of-type(3n) {
      border-right: 1px solid #f2f2f2;
    }
  }

  img {
    width: 70px;
    margin-bottom: 10px;
  }

  .title {
    font-weight: bold;
    font-size: 1.1rem;
    margin-bottom: 12px;
  }

  .item {
    display: block;
    margin-bottom: 8px;

    &:last-child {
      margin-bottom: 0;
    }
  }
`;
